import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(
    private loggerService: LoggerService,
  ) { }

  handleError(error, message?) {
    this.loggerService.error('GlobalErrorHandlerService catch error', error);
  }
}
